<div #baseContainer [formGroup]="rfForm" id="rating-form">
	<!-- OB List -->
	<div class="relative pt-10 transition-all duration-100" [class.pt-32]="loadexpandManeuver">
		<div class="fixed top-[204px] z-10 bg-white px-6 pb-4 shadow-sm" [style.width]="baseContainerWidth + 'px'">
			<div class="flex w-full items-start gap-10">
				<div #customTabContainer class="custom-tab-container" [class.expanded]="loadexpandManeuver">
					<div
						class="custom-tab"
						[ngClass]="{
							'grid-cols-5': maneuvers.length > 0,
							'lg:grid-cols-5': maneuvers.length <= 5,
							'lg:grid-cols-6': maneuvers.length === 6,
							'lg:grid-cols-7': maneuvers.length === 7,
							grid: maneuvers.length < 8,
							'lg:grid-cols-8': maneuvers.length >= 8,
							'lg:flex': !loadexpandManeuver && maneuvers.length > 8,
							flex: !loadexpandManeuver && maneuvers.length > 5,
						}"
					>
						@for (maneuver of maneuvers; track maneuver; let i = $index) {
							@if (maneuver != CONSTANT.DUMMY_PLACEHOLDER) {
								<div>
									<div
										class="tab-item"
										[ngStyle]="{
											'z-index': 10 + (maneuvers.length - i),
										}"
										[class.active]="i == tabIndex"
										[class.incomplete]="TEMValue[i] === 0"
										[class.complete]="TEMValue[i] > 0 && TEMValue[i] <= 5"
										[class.na]="TEMValue[i] === -1"
										[matTooltip]="maneuver"
										[matTooltipClass]="'whitespace-pre-line fix-tooltip-width'"
										(click)="setTabIndex(i)"
									>
										<div class="tab-label">
											{{ maneuver }}
										</div>
									</div>
								</div>
							}
						}
					</div>
				</div>
				<div
					[ngClass]="{
						hidden: maneuvers.length <= 5,
						'lg:hidden': maneuvers.length <= 8,
						'lg:block': maneuvers.length > 8,
						block: maneuvers.length > 5,
					}"
				>
					<button
						(click)="onManeuverExpand()"
						type="button"
						class="flex h-10 w-10 cursor-pointer items-center justify-center rounded py-2 hover:bg-grey-10"
					>
						@if (loadexpandManeuver) {
							<img class="h-full w-auto scale-150" src="/assets/icon_maneuver_collapse.svg" alt="" />
						}
						@if (!loadexpandManeuver) {
							<img class="h-full w-auto" src="/assets/icon_maneuver_expand.svg" alt="" />
						}
					</button>
				</div>
			</div>
		</div>

		<div class="ml-5 mt-5">Please Select OB</div>

		<mat-tab-group
			[disablePagination]="true"
			disableRipple
			class="-mt-5"
			[class.expandManeuver]="loadexpandManeuver"
			#maneuverTabs
			(selectedTabChange)="selectedTabValue($event)"
		>
			@for (maneuver of maneuvers; track maneuver; let i = $index) {
				<mat-tab>
					<ng-container formArrayName="observations">
						@if (observations.controls.length > 0) {
							@for (maneuverOB of observations.controls; track maneuverOB; let i = $index) {
								@if (maneuver === maneuverOB.get("maneuver")?.value && loaded) {
									<app-add-maneuver-form-v2
										[maneuverForm]="observations.at(i)"
										[isManeuverVisible]="false"
										[isSafetyOutcomeVisible]="false"
										[tabIndex]="maneuverTabs"
										(selectedOBList)="listallOBComments($event)"
										[obComments]="obComments"
									></app-add-maneuver-form-v2>

									<!-- Safety Outcome -->
								}
							}
						}
					</ng-container>
				</mat-tab>
			}
		</mat-tab-group>
	</div>
</div>

<!-- Instructor Notes/Comments -->
<div
	class="mb-6 mt-5 flex h-[40px] items-center justify-start bg-blue-20 px-4 text-lg font-bold text-black lg:bg-violet-light lg:text-violet"
>
	Instructor Notes/Comments
</div>
<div class="mb-8 grid grid-cols-1 gap-8 p-4 lg:grid-cols-2">
	<div>
		<p class="text-sm text-grey-60">Summary</p>
		<div
			class="border-1 flex h-[150px] flex-col items-stretch justify-stretch rounded border border-[#CFE3FF] text-[85%] uppercase"
		>
			<div class="flex-1 overflow-x-hidden p-3">
				@for (comment of obComments; track comment; let i = $index) {
					<div class="grid grid-cols-6 lg:grid-cols-4">
						<div>
							@if (comment?.ob !== "TEM" && comment?.ob !== "REPEAT") {
								@if (comment?.lastActionDisabled || comment?.isDisabled) {
									<span class="text-yellow">{{ comment?.ob }}</span>
								} @else {
									<span [class.text-green]="comment?.action" [class.text-red]="!comment?.action">
										{{ comment?.ob }}
									</span>
								}
							}
							@if (comment?.ob === "TEM") {
								<span
									[class.text-green]="(comment?.rate ?? 0) > 1"
									[class.text-red]="(comment?.rate ?? 0) <= 1"
									[class.text-yellow]="(comment?.rate ?? 0) === -1"
								>
									{{ comment?.maneuver }} {{ comment?.ob }}
								</span>
							}
							@if (comment?.ob === "REPEAT") {
								<span class="text-yellow">
									{{ comment?.ob }}
								</span>
							}
							@if (comment?.ob !== "TEM" && comment?.ob !== "REPEAT") {
								@if (comment?.lastActionDisabled) {
									<span class="text-yellow">{{ "{ Undo N/A }" }}</span>
								} @else if (comment?.isDisabled) {
									<span class="text-yellow">{{ "{ N/A }" }}</span>
								} @else if (comment?.action != null) {
									<span [class.text-green]="comment?.action" [class.text-red]="!comment?.action">
										{{ comment?.action ? "{ added }" : "{ removed }" }}
									</span>
								}
							}
							@if (comment?.ob === "TEM") {
								<span
									[class.text-green]="(comment?.rate ?? 0) > 1"
									[class.text-red]="(comment?.rate ?? 0) <= 1"
									[class.text-yellow]="(comment?.rate ?? 0) === -1"
								>
									{{ "{ " + comment?.remarks + " }" }}
								</span>
							}
						</div>
						@if (!comment?.lastActionDisabled && !comment?.isDisabled) {
							<span class="col-span-4 line-clamp-1 text-ellipsis lg:col-span-2">{{ comment?.instructorComment }}</span>
						}
					</div>
				}
			</div>

			<div class="flex items-center justify-end px-3 pb-3">
				<button
					(click)="viewSummaryModal()"
					class="size-6 rounded-sm bg-red pt-1 text-center text-white lg:size-8"
					matTooltip="View/Edit Comments"
				>
					<mat-icon class="text-xs lg:text-base">edit</mat-icon>
				</button>
			</div>
		</div>
	</div>
	<div>
		<p class="text-sm text-grey-60">Other Training & Observations</p>
		<div class="border-1 h-[150px] overflow-auto rounded border border-[#CFE3FF]" [formGroup]="rfForm">
			@for (maneuver of maneuvers; track maneuver; let i = $index) {
				<ng-container formArrayName="observations">
					@if (observations.controls.length > 0) {
						@for (maneuverOB of observations.controls; track maneuverOB; let i = $index) {
							@if (maneuver === maneuverOB.get("maneuver")?.value && i == 0) {
								<app-other-training-comments [maneuverForm]="observations.at(i)" [tabIndex]="tabIndex">
								</app-other-training-comments>
							}
						}
					}
				</ng-container>
			}
		</div>
	</div>
</div>
